import request from '@/utils/request';

async function baseRequest(path, payload, method) {
  return request({
    url: `/deployment-service/project/${path}`,
    method,
    data: method === 'get' ? null : payload,
    params: method === 'get' ? payload : null,
  });
}

export function createProject(payload) {
  return baseRequest('create', payload, 'post');
}
export function getProjectAll(payload) {
  return baseRequest('query_all', payload, 'get');
}
export function deleteProject(payload) {
  return baseRequest(`delete?id=${payload}`, null, 'delete');
}
export function queryDetail(payload) {
  return baseRequest('query_detail', payload, 'get');
}
export function updateProject(payload) {
  return baseRequest('update', payload, 'put');
}
